import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { ProductGroup } from 'src/app/order/models/product-group.model';
import { ProductGroupService } from '../../services/product-group.service';
import { ProductGroupValidatorService } from '../../validators/product-group-validator.service';

@Component({
    selector: 'app-product-groups-edit',
    templateUrl: './product-groups-edit.component.html',
    styleUrls: ['./product-groups-edit.component.scss'],
    standalone: false
})
export class ProductGroupsEditComponent implements OnInit {

  productGroup: ProductGroup = new ProductGroup();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private productGroupValidator: ProductGroupValidatorService,
    private productGroupService: ProductGroupService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadProductGroup(+params['id']);
    })
  }

  loadProductGroup(id: number): void {
    this.productGroupService.getProductGroupById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((productGroup: ProductGroup) => {
      this.productGroup = productGroup;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.isSuccess = false;

    if (this.productGroupValidator.isValid(this.productGroup)) {
      this.productGroupService.updateProductGroup(this.productGroup)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }
}
